import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import NodeWrapper from "./NodeWrapper";
import { Message } from "@mui/icons-material";

const MessageNode = memo(({ id, data, isConnectable, selected }) => {
  const label = data?.label || "";

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<Message />}
      title="Mensagem"
      color="#555"
      bgColor="#fafafa"
      isConnectable={isConnectable}
      selected={selected}
    >
      {label ? (
        <div
          style={{
            fontSize: 11,
            color: "#333",
            lineHeight: 1.45,
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            maxWidth: 200,
            background: "#f0f0f0",
            borderRadius: 6,
            padding: "6px 8px",
            borderLeft: "3px solid #3aba38",
          }}
        >
          <span style={{ marginRight: 4 }}>{"✅"}</span>
          {label}
        </div>
      ) : (
        <div
          style={{
            fontSize: 11,
            color: "#999",
            fontStyle: "italic",
            padding: "4px 0",
          }}
        >
          Mensagem vazia
        </div>
      )}
    </NodeWrapper>
  );
});

MessageNode.displayName = "MessageNode";
export default MessageNode;
